import "./Card.css";
import type { CardType } from "../game/useMemoryGame";

type Props = {
  card: CardType;
  isFlipped: boolean;
  onClick: () => void;
};

export function Card({ card, isFlipped, onClick }: Props) {
  const handleClick = () => {
    if (!card.matched) onClick();
  };

  return (
    <div className={`card ${isFlipped || card.matched ? "flipped" : ""}`} onClick={handleClick}>
      <div className="card-inner">
        <div className="card-front" />
        <div className="card-back">
          <img src={card.image} alt="card" loading="lazy" />
        </div>
      </div>
    </div>
  );
}